module.exports = __webpack_public_path__ + "img/logo-solo.eea21350.svg";